import React, { memo, type HTMLAttributes, type ReactNode } from "react";

interface CustomParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  className?: string;
  children: ReactNode;
}

function CustomParagraph({
  className = "",
  children,
  ...rest
}: CustomParagraphProps) {
  return (
    <p className={className} {...rest}>
      {children}
    </p>
  );
}

export default memo(CustomParagraph);
